export interface AiScrubBatchConflictError {
  kind: 'ai-scrub-batch-conflict';
  batchRunId: string;
}

export const isAiScrubBatchConflictError = (value: unknown): value is AiScrubBatchConflictError =>
  typeof value === 'object'
  && value !== null
  && (value as AiScrubBatchConflictError).kind === 'ai-scrub-batch-conflict'
  && typeof (value as AiScrubBatchConflictError).batchRunId === 'string';
